import Color from 'color'
import { css, styled } from 'styled-components'

import { Reset } from '@/lib/mixins'

export const ButtonLabel = styled.span`
  text-transform: uppercase;
  font-size: 18px;
  font-family: ${props => props.theme.font.primary};
  font-weight: 600;

  ${props =>
    props.size === 'lg' &&
    css`
      font-size: 20px;
      letter-spacing: 2px;
    `};

  ${props =>
    props.size === 'xl' &&
    css`
      font-size: 24px;
      letter-spacing: 2px;
    `};

  ${props =>
    props.size === 'sm' &&
    css`
      font-size: 16px;
      letter-spacing: 1px;
    `};
`

export const ButtonWrapper = styled.button`
  ${Reset('button')}
  z-index: 3;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  border-radius: 100px;
  color: ${props => props.theme.color.white};

  ${props =>
    props.addRightMargin &&
    css`
      margin-right: 8px;
    `};

  ${props =>
    props.size === 'default' &&
    css`
      height: 60px;
      padding: 0 35px;
    `};

  ${props =>
    props.size === 'xl' &&
    css`
      height: 100px;
      padding: 0 75px;
    `};

  ${props =>
    props.size === 'lg' &&
    css`
      height: 78px;
      padding: 0 50px;
    `};

  ${props =>
    props.size === 'sm' &&
    css`
      height: 40px;
      padding: 0 20px;
    `};

  ${props =>
    props.variant === 'primary' &&
    css`
      background-color: ${props.isPressed ? Color(props.theme.color.primary).darken(0.1) : props.theme.color.primary};
    `};

  ${props =>
    props.disabled &&
    css`
      opacity: 0.5;
    `};

  ${props =>
    props.variant === 'secondary' &&
    css`
      background-color: ${props.theme.color.light};
      color: ${props.theme.color.primary};
    `};

  ${props =>
    props.variant === 'tertiary' &&
    css`
      background-color: ${props => (props.theme.colorScheme === 'DARK' ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.1)')};
    `};

  ${props =>
    props.variant === 'red' &&
    css`
      background-color: ${props.isPressed ? Color(props.theme.color.red).darken(0.1) : props.theme.color.red};
    `};

  ${props =>
    props.variant === 'outline' &&
    css`
      background-color: ${props.isPressed ? 'rgba(255,255,255,0.1)' : 'transparent'};
      border: 2px solid ${props.theme.color.global};
      color: inherit;
    `};

  ${props =>
    props.variant === 'outline-dark' &&
    css`
      background-color: ${props.isPressed ? 'rgba(0,0,0,0.1)' : 'transparent'};
      border: 2px solid ${props.theme.color.black};
      color: inherit;
    `};
`

export const ButtonIcon = styled.span`
  margin-right: 12px;
  width: 28px;
  height: 28px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -13px;

  svg {
    width: 50%;
    height: 50%;
    fill: white;
  }

  ${props =>
    props.variant === 'secondary' &&
    css`
      background-color: ${props.theme.color.primary};
    `};
  ${props =>
    props.variant === 'tertiary' &&
    css`
      background-color: rgba(0, 0, 0, 0.5);
    `};
`
